<template>
  <div id="AboutUs">
    <Hero class="lift" :formats="['webp']" src="../../../assets/about-us.jpg">
      <Row>
        <Column :lg="6">
          <h1 class="title">
            {{ $t('title') | lineBreak }}
          </h1>
        </Column>
        <Column :lg="6">
          <div class="hero-side-text">
            <p>{{ $t('side') }}</p>
          </div>
        </Column>
      </Row>
    </Hero>

    <SectionSolar />
    <SectionWhyUsAbout />
    <Feedbacks />
    <!-- <SectionDiploma /> -->
    <!-- <SectionCertificates /> -->
  </div>
</template>

<script>

import { actions, getters } from 'views/utils'
import Feedbacks from 'views/components/Feedbacks'
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'
// import SectionCertificates from './components/SectionCertificates'
// import SectionDiploma from './components/SectionDiploma'
import SectionSolar from './components/SectionSolar'
import SectionWhyUsAbout from './components/SectionWhyUsAbout'

export default {
  mixins: [
    Meta(require('@/assets/social/about-us.jpg')),
  ],
  components: {
    Hero,
    SectionSolar,
    // SectionCertificates,
    // SectionDiploma,
    SectionWhyUsAbout,
    Feedbacks,
  },
  computed: getters('locale'),
  methods: actions('FETCH_MEMBER'),
  created() {
    this.LOAD(this.FETCH_MEMBER())
  },
}
</script>

<style lang="scss">
#AboutUs {
  .Hero {
    h1 {
      text-align: left;
    }

    .image img {
      filter: brightness(0.65);
      height: 100%;
    }
  }

  .Hero-body {
    .title {
      white-space: pre-line;
    }

    .hero-side-text {
      @include lg {
        padding-left: 20%;
      }
    }
  }

  .SectionSplit.career {
    background: $white;

    h2 {
      margin-bottom: 1rem;
    }

    .Btn {
      margin-top: 1.5rem;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "meta": {
      "title": {
        "complement": "Nogrid",
        "inner": "Apie mus",
        "separator": "-"
      },
      "description": "Nogrid - atsinaujinančios energetikos rangos įmonė, kuri rūpinasi visais saulės energijos įdiegimo etapais nuo projektavimo iki priežiūros. Mumis pasitiki klientai iš gamybos, logistikos, mažmeninės prekybos ir kitų sektorių.",
      "title": "Apie mus"
    },
    "side": "Inovatyvių saulės energijos sprendimų namams ekspertai",
    "title": "Saulės elektrinės|ateities namams"
  }
}
</i18n>
